var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63149 3.29398C2.55098 4.06949 2 5.05026 2 6.02889C2 7.04684 2.59786 8.0701 3.76639 8.85761C4.36286 9.25959 4.82857 9.95239 4.82857 10.7889V13.7858C4.82857 13.863 4.8502 13.8959 4.86468 13.9133C4.88549 13.9384 4.92394 13.9663 4.9789 13.9805C5.03386 13.9946 5.08094 13.9888 5.1112 13.9768C5.13225 13.9685 5.16694 13.9502 5.2039 13.8825L6.96133 10.6652C7.1723 10.279 7.57379 10.0481 8 10.0481C9.7486 10.0481 11.2899 9.53792 12.3685 8.76379C13.449 7.98828 14 7.00752 14 6.02889C14 5.05026 13.449 4.06949 12.3685 3.29398C11.2899 2.51985 9.7486 2.00963 8 2.00963C6.2514 2.00963 4.71008 2.51985 3.63149 3.29398ZM8.4881 12.0468L6.95716 14.8495C5.86197 16.8544 2.82857 16.0729 2.82857 13.7858V10.7889C2.82857 10.7331 2.79337 10.6216 2.65235 10.5266C1.10101 9.48111 0 7.90005 0 6.02889C0 4.2328 1.01603 2.70153 2.46901 1.65868C3.92392 0.614455 5.88261 0 8 0C10.1174 0 12.0761 0.614455 13.531 1.65868C14.984 2.70153 16 4.2328 16 6.02889C16 7.82498 14.984 9.35625 13.531 10.3991C12.1886 11.3626 10.4172 11.9602 8.4881 12.0468Z",
    fill: "#454A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.ed65621627a236b48493ca1a0110781d.svg";
export { ForwardRef as ReactComponent };